const EFFECTIVE_DATE = "October 11, 2025";

const Card: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-2xl shadow-sm p-6">
    {children}
  </div>
);

export const ShippingPolicy: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto mt-20 mb-20 b-4 p-6 sm:p-8">
      <h1 className="text-3xl font-semibold mb-4">Shipping Policy</h1>
      <p className="text-sm text-gray-600 mb-6">
        Effective date: <strong>{EFFECTIVE_DATE}</strong>
      </p>

      <Card>
        <section className="mb-6">
          <h2 className="text-xl font-medium mb-2">Order processing</h2>
          <p className="text-gray-700 leading-relaxed">
            • Normal (non-custom) products: Orders are processed within 1–3
            business days. Delivery will be completed within{" "}
            <strong>10 days</strong> from the dispatch date depending on the
            delivery partner.
          </p>
          <p className="text-gray-700 leading-relaxed mt-2">
            • Custom resin art products: These are handcrafted on demand and
            require <strong>1–2 weeks</strong> for production. Delivery time
            after dispatch depends on the delivery partner.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-medium mb-2">Shipping area</h2>
          <p className="text-gray-700">
            Currently we ship to <strong>Kerala only</strong>. We are working to
            expand to more regions in the future.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-medium mb-2">Shipping charges</h2>
          <p className="text-gray-700">
            Shipping charges (if any) will be calculated and shown at checkout.
            In some promotions we may offer free shipping — such offers will be
            clearly shown at checkout.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-medium mb-2">
            Delivery partner & tracking
          </h2>
          <p className="text-gray-700 leading-relaxed">
            We will share tracking information when orders are dispatched (if
            available). The exact delivery time depends on the courier/partner
            used. We currently evaluate and select delivery partners based on
            cost, reliability and coverage.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-medium mb-2">
            Custom orders and WhatsApp payments
          </h2>
          <p className="text-gray-700 leading-relaxed">
            For custom resin art orders we provide an option to continue on
            WhatsApp for design discussion and payment. UPI (QR or UPI ID)
            payments via WhatsApp are processed outside of the Fleeby checkout —
            please keep the payment screenshot and transaction details as a
            proof of payment. If you pay via UPI on WhatsApp, inform us on the
            same WhatsApp thread and attach the payment confirmation so we can
            link your payment to the order.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-medium mb-2">Razorpay payments</h2>
          <p className="text-gray-700">
            Online payments on the Fleeby checkout are processed using Razorpay.
            If a payment fails or an order isn’t created, please contact support
            immediately with your order and payment details.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-medium mb-2">
            Contact for shipping queries
          </h2>
          <p className="text-gray-700 mb-2">
            If you have questions about shipping, delivery or timelines, contact
            us:
          </p>
          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            <div className="flex-1">
              <p className="text-sm text-gray-600">
                Email:{" "}
                <a href="mailto:info@fleeby.in" className="underline">
                  info@fleeby.in
                </a>
              </p>
              <p className="text-sm text-gray-600">
                Phone/Support:{" "}
                <a href="tel:+917778461609" className="underline">
                  +91 97784 61609
                </a>
              </p>
            </div>
            <div className="text-sm text-gray-500">
              Small business — quick, personalised support.
            </div>
          </div>
        </section>
      </Card>

      <p className="text-xs text-gray-500 mt-4">
        Note: This policy may be updated from time to time — please check the
        date above for the latest version.
      </p>
    </div>
  );
};
